/**
 * AOS scroll library
 * https://michalsnik.github.io/aos/
 */

const HELLOPANDA_AOS = {
  init: function() {

    let AOS;

    try {
      AOS = require("aos");
    } catch (error) {
      console.warn("AOS module not found, the AOS effect is disabled.");
    }    

    if (typeof AOS === 'object') {
      // 선택적 설정 객체를 전달할 수 있습니다
      // 아래에 나열된 기본 설정
      AOS.init({
        // 전역 설정:
        disable: false, // 가능한 값: 'phone', 'tablet', 'mobile', boolean, 표현식 또는 함수
        // startEvent: 'DOMContentLoaded', // AOS가 초기화되어야 하는 문서에서 전달된 이벤트의 이름
        startEvent: 'hellopanda-theme-aos:trigger', // AOS가 초기화되어야 하는 문서에서 전달된 이벤트의 이름
        initClassName: 'aos-init', // 초기화 후 적용되는 클래스
        animatedClassName: 'aos-animate', // 애니메이션 중에 적용되는 클래스
        useClassNames: false, // true이면 `data-aos`의 내용을 스크롤시 클래스로 추가합니다.
        disableMutationObserver: false, // 자동 변형 감지를 비활성화합니다. (고급)
        debounceDelay: 50, // 창 크기 조절시 대기 시간 지연 (고급)
        throttleDelay: 99, // 페이지 스크롤시 대기 시간 지연 (고급)
        
        // 요소별로 덮어쓸 수 있는 설정, `data-aos-*` 속성에 의해:
        offset: 500, // 원본 트리거 지점으로부터 오프셋 (px)
        delay: 0, // 0에서 3000까지의 값, 단위는 50ms
        duration: 400, // 0에서 3000까지의 값, 단위는 50ms
        easing: 'ease', // AOS 애니메이션의 기본 이징
        once: false, // 애니메이션이 한 번만 발생할지 여부 - 아래로 스크롤시
        mirror: false, // 요소가 지나갈 때 요소가 외부에서 애니메이션되어야 하는지 여부
        anchorPlacement: 'top-bottom', // 창에 대한 요소의 위치를 정의하여 애니메이션을 트리거할지 여부를 정의합니다.
      });

      window.addEventListener('DOMContentLoaded', () => {
        document.dispatchEvent(new Event('hellopanda-theme-aos:trigger'));
      });

    }

  }
};
HELLOPANDA_AOS.init();